import { createApp } from 'vue'
import App from './App.vue'
// import Vue from 'vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createWebHistory,createRouter } from 'vue-router'
// import router from './router/routers'
// import 'element-plus/lib/theme-chalk/index.css'

const app = createApp(App)


import tmIntroduce from '@/views/tmIntroduce'
import introduce from '@/views/introduce'
import about from '@/views/about'
import screenQuote from '@/views/screenQuote'
import quotation from '@/views/quotation'



export const constantRouterMap = [
  { path: '/tmIntroduce',
  component: tmIntroduce,
  },
   { path: '/about',
  component: about,
  },
  { path: '/screenQuote',
  component: screenQuote,
  },
   { path: '/quotation',
  component: quotation,
  },

  {
    path: '/',
    
    redirect: '/introduce',
    children: [
      {
        path: 'introduce',
        component: introduce,
        name: 'introduce',
        meta: { title: '首页', icon: 'index', affix: true, noCache: true }
      }
    ]
  },
]

  const router = createRouter({
    // mode: 'hash',
    // mode: 'history',
    history: createWebHistory(),
    routes: constantRouterMap
  })

app.use(ElementPlus)
app.use(router)
app.mount('#app')

window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

// new Vue({
//     el: '#app',
//     router,
//     ElementPlus,
//     render: h => h(App)
//   })